/**
 * Initialize all custom scripts on DOM ready
 * @returns {void}
 */
document.addEventListener('DOMContentLoaded', function() {
    initAgeVerification()
    initHeroSlider()
});

/**
 * Age Verification Modal
 * Handles the age verification popup functionality
 * @returns {void}
 */
function initAgeVerification() {
    // const modal = document.getElementById('ageVerification');
    // const yesBtn = document.getElementById('ageVerifyYes');
    // const noBtn = document.getElementById('ageVerifyNo');
    
    // if (!modal) return;
    
    // // Always show modal on homepage
    // document.body.classList.add('age-verification-active');
    
    // // Yes button - verify and allow access
    // if (yesBtn) {
    //     yesBtn.addEventListener('click', function() {
    //         modal.classList.add('hidden');
    //         document.body.classList.remove('age-verification-active');
    //     });
    // }
    
    // // No button - redirect away
    // if (noBtn) {
    //     noBtn.addEventListener('click', function() {
    //         window.location.href = 'https://www.google.com';
    //     });
    // }

        /** @type {HTMLElement | null} */
        const ageModal = document.getElementById('ageVerification');
        /** @type {HTMLElement | null} */
        const yesBtn = document.getElementById('ageVerifyYes');
        /** @type {HTMLElement | null} */
        const noBtn = document.getElementById('ageVerifyNo');
    // Exclude popup on Terms & Conditions page
    if (window.location.pathname.includes('/pages/terms-condition')) return;

    if (!ageModal) return;
        // Check cookie
        if (!document.cookie.split('; ').find((row) => row.startsWith('age_verified=true'))) {
          // Remove hidden class if present
          ageModal.classList.remove('tw:hidden!');
        }
     if (yesBtn) {
        yesBtn.addEventListener('click', function () {
          // Set cookie for 7 days
          document.cookie = 'age_verified=true; max-age=' + 7 * 24 * 60 * 60 + '; path=/';
          ageModal.classList.add('tw:hidden!');
        })
    }
    if (noBtn) {

        noBtn.addEventListener('click', function () {
          window.location.href = 'https://google.com'; // Redirect if under age
        });
    }
}


/**
 * Hero Slider Class
 * Manages carousel/slider functionality with touch and mouse support
 * @class
 */
class HeroSlider {
    /**
     * Creates a new HeroSlider instance
     * @param {HTMLElement | null} element - The slider container element
     */
    constructor(element) {
        if (!element) return;
        
        /** @type {HTMLElement} */
        this.slider = element;
        /** @type {HTMLElement | null} */
        this.wrapper = this.slider.querySelector('.slider-wrapper');
        /** @type {NodeListOf<HTMLElement>} */
        this.slides = this.slider.querySelectorAll('.slide');
        /** @type {NodeListOf<HTMLElement>} */
        this.dots = this.slider.querySelectorAll('.dot');
        /** @type {HTMLElement | null} */
        this.prevBtn = this.slider.querySelector('.slider-prev');
        /** @type {HTMLElement | null} */
        this.nextBtn = this.slider.querySelector('.slider-next');

        if (!this.wrapper || this.slides.length === 0) return;

        /** @type {number} Current slide index */
        this.currentSlide = 0;
        /** @type {number | null} Autoplay interval ID */
        this.autoplayInterval = null;
        /** @type {number} Autoplay delay in milliseconds */
        this.autoplayDelay = 5000; // 5 Seconds default

        /** @type {boolean} Whether the slider is being dragged */
        this.isDragging = false;
        /** @type {number} Starting position of drag */
        this.startPos = 0;
        /** @type {number} Current translate position */
        this.currentTranslate = 0;
        /** @type {number} Previous translate position */
        this.prevTranslate = 0;
        /** @type {number} Animation frame ID */
        this.animationID = 0;
        /** @type {number} Current index (unused but kept for compatibility) */
        this.currentIndex = 0;
        /** @type {number} Timestamp when drag started */
        this.startTime = 0;
        /** @type {boolean} Whether to block click event */
        this.clickBlocked = false;

        // Check for data attributes for autoplay settings if needed
        if (this.slider.dataset.delay) {
            this.autoplayDelay = parseInt(this.slider.dataset.delay);
        }

        this.init();
    }

    /**
     * Initialize the slider
     * @returns {void}
     */
    init() {
        this.addEventListeners();
        this.updatePosition();
        this.startAutoplay();
    }

    /**
     * Add all event listeners for slider controls
     * @returns {void}
     */
    addEventListeners() {
        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', () => {
                this.prevSlide();
                this.resetAutoplay();
            });
        }

        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => {
                this.nextSlide();
                this.resetAutoplay();
            });
        }

        this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                this.currentSlide = index;
                this.updatePosition();
                this.updateDots();
                this.resetAutoplay();
            });
        });

        // Touch events
        this.slider.addEventListener('touchstart', this.touchStart.bind(this), { passive: true });
        this.slider.addEventListener('touchend', this.touchEnd.bind(this));
        this.slider.addEventListener('touchmove', this.touchMove.bind(this), { passive: true });

        // Mouse events
        this.slider.addEventListener('mousedown', this.touchStart.bind(this));
        this.slider.addEventListener('mouseup', this.touchEnd.bind(this));
        this.slider.addEventListener('mouseleave', () => {
            if (this.isDragging) this.touchEnd();
        });
        this.slider.addEventListener('mousemove', this.touchMove.bind(this));
        
        // Capture click events to prevent navigation during drag
        this.slider.addEventListener('click', this.handleClick.bind(this), true);
        
        // Prevent context menu
        this.slider.oncontextmenu = function(event) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        };
    }

    /**
     * Handle click event
     * @param {MouseEvent} event 
     */
    handleClick(event) {
        if (this.clickBlocked) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
    }

    /**
     * Handle touch/mouse start event
     * @param {TouchEvent | MouseEvent} event - The touch or mouse event
     * @returns {void}
     */
    touchStart(event) {
        this.clickBlocked = false;
        this.isDragging = true;
        this.startPos = this.getPositionX(event);
        this.startTime = Date.now();
        this.animationID = requestAnimationFrame(this.animation.bind(this));
        if (!this.wrapper) return;
        this.wrapper.style.transition = 'none'; // Instant follow
        this.stopAutoplay();
    }

    /**
     * Handle touch/mouse move event
     * @param {TouchEvent | MouseEvent} event - The touch or mouse event
     * @returns {void}
     */
    touchMove(event) {
        if (this.isDragging) {
            const currentPosition = this.getPositionX(event);
            const diff = currentPosition - this.startPos;
            
            // If moved more than 10px, prevent default to stop link navigation
            if (Math.abs(diff) > 10) {
                event.preventDefault();
            }
            
            this.currentTranslate = this.prevTranslate + diff;
        }
    }

    /**
     * Handle touch/mouse end event
     * @param {TouchEvent | MouseEvent} [event] - The touch or mouse event
     * @returns {void}
     */
    touchEnd(event) {
        if (!this.isDragging) return;
        
        const movedBy = this.currentTranslate - this.prevTranslate;
        const timeDiff = Date.now() - this.startTime;
        
        // If significant movement, prevent link click
        // We only check for movement (drag), simple clicks (even slow ones) should still work.
        if (Math.abs(movedBy) > 10) {
            this.clickBlocked = true;
            if (event && event.preventDefault && event.cancelable) {
                event.preventDefault();
            }
        }
        
        this.isDragging = false;
        cancelAnimationFrame(this.animationID);

        // Threshold for swipe
        if (movedBy < -100 && this.currentSlide < this.slides.length - 1) {
            this.currentSlide += 1;
        } else if (movedBy > 100 && this.currentSlide > 0) {
            this.currentSlide -= 1;
        } else {
             // Wrap around logic checks or snap back
             if (movedBy < -100 && this.currentSlide === this.slides.length - 1) {
                  this.currentSlide = 0; // Loop forward to start
             } else if (movedBy > 100 && this.currentSlide === 0) {
                  this.currentSlide = this.slides.length - 1; // Loop back to end
             }
        }

        this.updatePosition();
        this.resetAutoplay();
    }

    /**
     * Get X position from touch or mouse event
     * @param {TouchEvent | MouseEvent} event - The touch or mouse event
     * @returns {number} The X coordinate
     */
    getPositionX(event) {
        if (event.type.includes('mouse')) {
            return /** @type {MouseEvent} */ (event).pageX;
        } else {
            const touchEvent = /** @type {TouchEvent} */ (event);
            return touchEvent.touches[0]?.clientX || 0;
        }
    }

    /**
     * Animation loop for smooth dragging
     * @returns {void}
     */
    animation() {
        if (this.isDragging) {
            this.setSliderPosition();
            requestAnimationFrame(this.animation.bind(this));
        }
    }

    /**
     * Set the slider wrapper position
     * @returns {void}
     */
    setSliderPosition() {
        if (!this.wrapper) return;
        this.wrapper.style.transform = `translateX(${this.currentTranslate}px)`;
    }

    /**
     * Update slider position to current slide
     * @returns {void}
     */
    updatePosition() {
        if (!this.wrapper) return;
        this.wrapper.style.transition = 'transform 0.5s ease-out';
        this.currentTranslate = this.currentSlide * -this.slider.offsetWidth;
        this.prevTranslate = this.currentTranslate;
        this.setSliderPosition();
        this.updateDots();
    }

    /**
     * Update active state of navigation dots
     * @returns {void}
     */
    updateDots() {
        this.dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === this.currentSlide);
        });
    }

    /**
     * Navigate to next slide
     * @returns {void}
     */
    nextSlide() {
        if (this.currentSlide < this.slides.length - 1) {
            this.currentSlide++;
        } else {
            this.currentSlide = 0;
        }
        this.updatePosition();
    }

    /**
     * Navigate to previous slide
     * @returns {void}
     */
    prevSlide() {
        if (this.currentSlide > 0) {
            this.currentSlide--;
        } else {
            this.currentSlide = this.slides.length - 1;
        }
        this.updatePosition();
    }
    
    /**
     * Start autoplay interval
     * @returns {void}
     */
    startAutoplay() {
        this.stopAutoplay();
        this.autoplayInterval = setInterval(() => {
            this.nextSlide();
        }, this.autoplayDelay);
    }

    /**
     * Stop autoplay interval
     * @returns {void}
     */
    stopAutoplay() {
        if (this.autoplayInterval) {
            clearInterval(this.autoplayInterval);
        }
    }

    /**
     * Reset autoplay (stop and restart)
     * @returns {void}
     */
    resetAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
    }
}

/**
 * Global init function for hero sliders
 * Initializes all hero sliders on the page
 * @returns {void}
 */
function initHeroSlider() {
    const sliders = document.querySelectorAll('.hero-slider');
    sliders.forEach(slider => new HeroSlider(/** @type {HTMLElement} */ (slider)));
}

/**
 * Shopify Section Load Support
 * Reinitialize slider when section is loaded in theme editor
 */
document.addEventListener('shopify:section:load', function(event) {
    const target = /** @type {Element} */ (event.target);
    const heroSlider = target.querySelector('.hero-slider');
    if (heroSlider) {
        new HeroSlider(/** @type {HTMLElement} */ (heroSlider));
    }
});
